'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { GetCookie, SetCookie } from '@/src/cookies/CookiesSetUp';
import { Affiliate, AffiliateGaid } from '@/src/cookies/CookiesType';

// The POP /promo/affiliate flow only carries the partner id as `gAID`; the
// RTG integration (signup, CDK.getAffId) reads the `affid` cookie. Mirror
// gAID into affid when no real affid is present so affiliate attribution is
// not lost. A real affid (legacy aiddownload.asp) always wins.
// See mro-casino-2026 components/layout/ClientRouteEffects.tsx (same pattern).
export default function AffiliateGaidMirror() {
  const pathname = usePathname();

  useEffect(() => {
    try {
      if (GetCookie(Affiliate)) return;
      const gAID = GetCookie(AffiliateGaid);
      if (gAID && /^\d+$/.test(gAID)) {
        SetCookie(Affiliate, gAID);
      }
    } catch {
      // never break navigation for an attribution convenience
    }
  }, [pathname]);

  return null;
}
